import { PureComponent } from 'react'
import errorLogging from 'services/error-logging'

type Props = {
  children: React.ReactNode
  fallback: React.ReactNode
}

type State = {
  hasError: boolean
}

class ErrorBoundary extends PureComponent<Props, State> {
  static defaultProps = {
    className: '',
    fallback: null,
  }

  state = {
    hasError: false,
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(
    error: Error,
    errorInfo: {
      componentStack: string
    },
  ) {
    errorLogging(error, { errorInfo })
  }

  render() {
    const { children, fallback } = this.props
    const { hasError } = this.state

    return hasError ? fallback : children
  }
}

export default ErrorBoundary
